import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-reset-password-modal',
  templateUrl: './reset-password-modal.page.html',
  styleUrls: ['./reset-password-modal.page.scss'],
})
export class ResetPasswordModalPage implements OnInit {

  public apiUrl: string = "";
  public email: string = "";

  constructor(
    private httpClient: HttpClient,
    public modalController: ModalController,
    public messagesService: MessagesService
  ) { }

  ngOnInit() {
  }

  closeModal(){
    this.modalController.dismiss();
  }

  resetPassword(event){
    this.httpClient.get<any>(this.apiUrl + "authentication/passwordreset/" + this.email).subscribe((res: any) => {
      if (res.toString() == "Success")
        this.messagesService.presentToast("Your password has been reset, you should receive an email shortly.", "info", "Password Reset");
      else
        this.messagesService.presentToast("Your password has been reset, you should receive an email shortly.", "info", "Password Reset");

      this.closeModal();
    }, (error: any) => {
      if (error.error.text == "Success")
        this.messagesService.presentToast("Your password has been reset, you should receive an email shortly.", "info", "Password Reset");
      else
        this.messagesService.presentToast("Your password has been reset, you should receive an email shortly.", "info", "Password Reset");

      this.closeModal();
    });
  }
}
